/** Sequentially resolve newly matchable rows and retain only those still unresolved. */
export async function retainUnresolvedParticipants<T>(
  participants: T[],
  resolveAndAssign: (participant: T) => Promise<boolean>,
): Promise<T[]> {
  const unresolved: T[] = [];

  for (const participant of participants) {
    if (!(await resolveAndAssign(participant))) unresolved.push(participant);
  }

  return unresolved;
}
